const f = {
  color: {
    active: {
      outer: "#47c47dff",
      inner: "#b9edbdff"
    },
    pending: {
      outer: "#4176faff",
      inner: "#9ecbffff"
    },
    closed: {
      outer: "#c8d3deff",
      inner: "#556575ff"
    },
    spam: {
      outer: "#e54a32ff",
      inner: "#ffbcadff"
    }
  }
};
export {
  f as convoStatusSymbol
};
